export default __webpack_public_path__ + "static/media/error-404.a5c1b5c6.png";